import { ReactNode } from 'react';
import styled from 'styled-components';
import { Icon } from '../component/Icon';

interface FullModalProps {
  children: ReactNode;
  onClose: () => void;
}

const FullModal = ({ children, onClose }: FullModalProps) => {
  return (
    <>
      <Wrap>
        <CloseBtn className="img-box" onClick={onClose}>
          <Icon name="CloseIcon" size="100%" color="#111" />
        </CloseBtn>
        <Content>{children}</Content>
      </Wrap>
    </>
  );
};

export default FullModal;

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  background: #fff;
`;

const CloseBtn = styled.button`
  width: 32px;
  position: absolute;
  right: 14px;
  top: 14px;
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;
